import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { hasClient } from 'src/lib/flow/text';

function isEnabled({ answers, inputContext: { inApp, homebuilderIdentifier } }: FlowContext) {
  const answeredWorkingWithHomeBuilder =
    typeof answers['seller.working_with_home_builder'] === 'boolean';
  return !inApp && (answeredWorkingWithHomeBuilder || !homebuilderIdentifier);
}

const homebuilderPage: FlowPage = {
  slug: () => 'home-builder',
  title: ({ answers, inputContext: { channel } }) =>
    `${hasClient(answers, channel) ? 'Is your client' : 'Are you'} working with a homebuilder?`,
  subtitle: () => 'We can work with them to line up your close dates.',
  isEnabled,
  autoAdvance: () => true,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.working_with_home_builder',
      type: 'radio_single_select',
      options: [
        {
          label: 'Yes',
          value: 'true',
        },
        {
          label: 'No',
          value: 'false',
        },
      ],
      keepAnswerIfHidden: true,
    },
  ],
};

export default homebuilderPage;
